/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  UserCheckBuyoutEligibilityParams,
  UserListUserAssetTransfersParams,
} from '../api'
import {
  checkBuyoutEligibility,
  listUserAssetTransfers,
} from './user-transfer.service'
import { EUserTransferQueryKey } from './user-transfer.types'

export const getListUserAssetTransfersOptions = (
  filter: UserListUserAssetTransfersParams,
) => {
  return {
    queryKey: [EUserTransferQueryKey.LIST_USER_ASSET_TRANSFERS, filter],
    queryFn: () => listUserAssetTransfers(filter),
  }
}

export const getCheckBuyoutEligibilityOptions = (
  filter: UserCheckBuyoutEligibilityParams,
) => {
  return {
    queryKey: [EUserTransferQueryKey.CHECK_BUYOUT_ELIGIBILITY, filter],
    queryFn: () => checkBuyoutEligibility(filter),
  }
}
export const getListUserAssetTransfersInfiniteOptions = (
  params: UserListUserAssetTransfersParams,
) => {
  return {
    queryKey: [EUserTransferQueryKey.LIST_USER_ASSET_TRANSFERS, params],

    queryFn: ({ pageParam = 0 }) =>
      listUserAssetTransfers({
        ...params,
        skip: pageParam * (params.limit || 10),
      }),
    staleTime: 1,
    getNextPageParam: (lastPage: any, allPages: any) => {
      const total = lastPage.data?.total

      const transactions = lastPage.data?.transactions || []
      const limit = params.limit || 10

      // If we have total count, use it for pagination
      if (total !== undefined && total !== null) {
        const currentLength = allPages.reduce(
          (acc: number, page: any) =>
            acc + (page.data?.transactions?.length || 0),
          0,
        )
        return currentLength < total ? allPages.length : undefined
      }

      // Fallback: If no total, check if we got fewer messages than requested
      // This indicates we've reached the end
      if (transactions.length < limit) {
        return undefined
      }

      // If we got exactly the limit, there might be more data
      return allPages.length
    },
    initialPageParam: 0,
  }
}
